import { Skeleton } from "@mui/material";

type SimpleEditorLoadingSkeletonProps = {
  label: string;
};

export const SimpleEditorLoadingSkeleton = ({
  label,
}: SimpleEditorLoadingSkeletonProps) => (
  <div
    aria-busy="true"
    aria-label={label}
    className="simple-editor-loading-skeleton"
    role="status"
  >
    <div className="simple-editor-loading-skeleton__lines" aria-hidden="true">
      <Skeleton height={32} variant="rounded" width="70%" />
      <Skeleton height={32} variant="rounded" width="82%" />
      <Skeleton height={32} variant="rounded" width="64%" />
    </div>
  </div>
);
